// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"357":"75dc1a89b96db8c7e266","649":"a2fce3c8f30454b9ba15"}[chunkId] + ".bundle.js";
};